import { HttpClient } from "@src/api/v1/http-client";
import { HttpClient as HttpClientV2 } from "@src/api/v2/http-client";
import { getApiBaseUrl } from "@src/utils/urlHelpers";

const config = {
  baseURL: getApiBaseUrl(),
  withCredentials: true,
};
export const OpenUpHttpClient = new HttpClient(config);
export const OpenUpHttpClientV2 = new HttpClientV2(config);
